import { render, staticRenderFns } from "./reserve-filter-vertical-new.vue?vue&type=template&id=532dc9c3&scoped=true"
import script from "./reserve-filter-vertical-new.vue?vue&type=script&lang=js"
export * from "./reserve-filter-vertical-new.vue?vue&type=script&lang=js"
import style0 from "./reserve-filter-vertical-new.vue?vue&type=style&index=0&id=532dc9c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532dc9c3",
  null
  
)

export default component.exports